export default {
  aboutPage: {
    seoTitle: 'À propos de Geofleet — Logiciel de gestion des livraisons avec IA',
    seoDescription:
      'Geofleet conçoit un logiciel de gestion des livraisons avec un Copilot IA, utilisé par plus de 100 clients dans plus de 20 pays. Certifié SOC 2 et ISO 27001, avec des tarifs publics à partir de 100 $ par mois pour 10 chauffeurs.',
    badge: 'À propos de Geofleet',
    title: 'Nous construisons le centre de commande',
    titleHighlight: 'des équipes de livraison',
    lead:
      'Geofleet est un logiciel de gestion des livraisons pour les équipes qui gèrent leur propre flotte. Les dispatchers planifient et suivent chaque arrêt depuis un seul centre de commande, les chauffeurs travaillent depuis une seule application et les clients suivent leur livraison via un lien de suivi en direct. Un Copilot IA se charge des tâches répétitives, dans la limite des permissions que vous définissez.',
    stats: [
      { value: '100+', label: 'Clients' },
      { value: '20+', label: 'Pays' },
      { value: '50+', label: 'Intégrations' },
      { value: '99,99 %', label: 'Disponibilité' },
    ],
    heroImageAlt: 'Le centre de commande Geofleet avec une carte des livraisons en direct, des KPIs et les commandes du jour',

    missionKicker: 'Pourquoi nous existons',
    missionTitle: 'La plupart des livraisons se gèrent encore par messagerie et tableur',
    missionBody: [
      'Dans la plupart des opérations de livraison, le plan tient dans un tableur, le dispatch se fait dans des groupes de discussion et les clients appellent pour savoir où en est leur commande. Chaque chauffeur en retard déclenche une série d’appels.',
      'Nous avons créé Geofleet pour réunir tout ce travail au même endroit. Les commandes arrivent, les tournées sont planifiées, les chauffeurs sont dispatchés, les clients restent informés et chaque livraison se termine par une preuve. Quand quelque chose dérape, le centre de commande le signale en premier et Copilot propose la solution.',
    ],
    missionQuote: 'Notre objectif : donner à chaque équipe de livraison les outils des grands transporteurs, sans long cycle de vente entreprise.',

    principlesKicker: 'Notre façon de travailler',
    principlesTitle: 'Ce en quoi nous croyons',
    principles: [
      {
        title: 'Le prix est affiché',
        body: 'Des tarifs publics, à partir de 100 $ par mois pour 10 chauffeurs. Vous devriez connaître le coût avant de parler à qui que ce soit.',
      },
      {
        title: 'Une IA avec des garde-fous',
        body: 'Copilot et nos agents IA agissent uniquement dans le périmètre du rôle de chaque utilisateur. Ils proposent, les personnes confirment, et chaque modification est journalisée.',
      },
      {
        title: 'Fondé sur les données en direct',
        body: 'Chaque réponse et chaque suggestion reposent sur ce qui se passe sur la route en ce moment, pas sur un texte IA générique.',
      },
      {
        title: 'La sécurité n’est pas une option',
        body: 'Geofleet est certifié SOC 2 et ISO 27001, avec des données chiffrées au repos et en transit et un contrôle d’accès par rôle sur toute la plateforme.',
      },
    ],

    productKicker: 'Ce que nous construisons',
    productTitle: 'Une seule plateforme, de la commande à la preuve de livraison',
    products: [
      { title: 'Centre de commande', body: 'Carte en direct, exceptions priorisées et toutes les commandes dans une seule vue.', href: '/how-it-works' },
      { title: 'Copilot et agents IA', body: 'Posez vos questions en langage naturel, automatisez le dispatch et résolvez les exceptions.', href: '/features/ai-agents' },
      { title: 'Planificateur de tournées', body: 'Des tournées optimisées selon les créneaux horaires, la capacité et le trafic.', href: '/features/route-planner' },
      { title: 'Application chauffeur', body: 'Navigation, preuve de livraison et pointage, même hors ligne.', href: '/features/driver-app' },
      { title: 'Suivi à votre marque', body: 'Un lien de suivi en direct que les clients ouvrent dans n’importe quel navigateur.', href: '/features/branded-tracking' },
      { title: 'Rapports et analyses', body: 'Taux de ponctualité, coût par livraison et fiches de performance des chauffeurs.', href: '/features/reports-analytics' },
    ],

    industriesKicker: 'Pour qui',
    industriesTitle: 'Des équipes qui livrent tous les jours',
    industriesBody:
      'Restaurants, pharmacies, services de coursiers, épiceries, commerces, distributeurs et équipes d’intervention terrain utilisent Geofleet dans plus de 20 pays, des flottes de 10 chauffeurs aux opérations multi-hubs.',
    industriesCta: 'Voir tous les secteurs',

    trustKicker: 'Confiance et sécurité',
    trustTitle: 'Une plateforme sur laquelle compter',
    trustItems: [
      { title: 'SOC 2', body: 'Des contrôles de sécurité audités de manière indépendante.' },
      { title: 'ISO 27001', body: 'Un système de management de la sécurité de l’information certifié.' },
      { title: '99,99 % de disponibilité', body: 'Une plateforme sur laquelle votre dispatch peut s’appuyer toute la journée.' },
      { title: 'Chiffrement et contrôle d’accès', body: 'Données chiffrées au repos et en transit, avec des permissions par rôle et des journaux d’audit.' },
    ],
    trustCta: 'Demander notre documentation sécurité',

    connectKicker: 'Travailler avec nous',
    connectTitle: 'Contactez-nous',
    connectCards: [
      { title: 'Essayer Geofleet', body: 'Commencez avec Geofleet Lite et vos propres commandes, à partir de 100 $ par mois pour 10 chauffeurs.', cta: 'Commencer' },
      { title: 'Parler à notre équipe', body: 'Réservez une démo et nous passerons en revue votre workflow de livraison.', cta: 'Réserver une démo' },
      { title: 'Devenir partenaire', body: 'Revendez ou intégrez Geofleet, avec un portail partenaire en libre-service.', cta: 'Programme partenaires' },
    ],
    contactLine: 'Questions générales :',
  },
};
